import { PlanActionTypes } from "../models/planActions";
import { PLAN_DECLINED } from "../types";

export default (data: string): PlanActionTypes => ({
    type: PLAN_DECLINED,
    payload: data,
});
